import { useEffect } from 'react';
const OnRenderWrapper = ({ children, onRenderCallback }) => {
    useEffect(() => {
        onRenderCallback();
    }, []);
    return children;
};
export default OnRenderWrapper;
